<template>
<div class="entry-modal">

<!-- {{entry.data}} -->

<div class="modal is-active" >
  <div class="modal-background" @click="close"></div>
  <div class="modal-card">
    <header class="modal-card-head">
      <p class="modal-card-title"><calendar-icon></calendar-icon>
        {{ timeAbsolute(entry.created_at) }}
      </p>
      <button class="delete" aria-label="close" @click="close"></button>
    </header>
    <ul class="modal-card-body">

      <li v-if="entry.meta && entry.meta.rejected.length > 0" class="rejected">
        <shield-icon></shield-icon><strong>This entry was rejected</strong>
        <p>Notifications were not sent and uploads were not saved.</p>
      </li>

      <li v-if="entry.meta && entry.meta.rejected.length > 0" >
        <strong>Rejection reasons:</strong>
        <p><code v-for="(reason, index) in entry.meta.rejected" :key="index">{{reason}} </code></p>
      </li>

      <li v-if="entry.meta && entry.meta.rejected.length > 0" class="rejectionOverride">
        <strong>Override entry rejection? <button @click="override">Override</button></strong>
        <p>This will send notifications now. Any attachments are not included.</p>
      </li>

      <li v-if="entry.meta && entry.meta.rejectOverride" class="rejectionOverride overridden">
        <shield-off-icon></shield-off-icon><strong>Entry rejection was overridden</strong>
        <p>Entry rejection was manually overridden.<br>{{ timeAbsolute(entry.meta.rejectOverride.time) }}.</p>
        <p v-if="entry.meta.rejectOverride.reasons.length > 0">Overridden Rejection Reasons:<br>
        <code v-for="(reason, index) in entry.meta.rejectOverride.reasons" :key="index">{{reason}} </code></p>
      </li>

      <li v-if="entry.data.name">
        <user-icon></user-icon><strong>Name</strong>
        <p>{{entry.data.name}}</p>
      </li>

      <li v-if="entry.data.phone" class="entry-phone">
        <phone-icon></phone-icon><strong>Phone</strong>
        <p>{{entry.data.phone}}</p>
      </li>

      <li v-if="entry.data.email" class="entry-email">
        <mail-icon></mail-icon><strong>Email</strong>
        <p>{{entry.data.email}}</p>
      </li>

      <li v-if="entry.data.message || entry.data.comments">
        <message-square-icon></message-square-icon><strong>Message</strong>
        <p>{{ entry.data.message || entry.data.comments }}</p>
      </li>

      <li v-if="entry.files" class="entry-filelist"><ul>
        <li class="entry-file" v-for="(file, index) in entry.files" :key="index">
          <file-icon></file-icon>
          <strong v-if="['png', 'jpg', 'gif', 'bmp'].includes(file.ext)">Attached Image</strong>
          <strong v-else>Attached File</strong>
          <div v-if="file.deleted">
            <p>File uploads are not stored for rejected entries.</p>
            <p>Deleted: {{fileSize(file.size)}} {{file.name}}</p>
          </div>
          <div v-else>
          <p><a :href="file.path" target="_blank" download>Download</a>
          ({{fileSize(file.size)}} {{file.name}})</p>
          <img v-if="['jpg', 'png', 'gif', 'bmp', 'webm', 'avif'].includes(file.ext)" :src="file.path">
          </div>
        </li>
      </ul></li>

      <li v-if="entry.data['Form URL']">
        <link-icon></link-icon><strong>Form URL</strong>
        <p>{{entry.data['Form URL']}}</p>
      </li>

      <li v-for="(field, index) in otherFields" :key="index">
        <strong>{{index}}</strong>
        <p>{{field}}</p>
      </li>

      <li v-if="entry.notifications">
      <details open>
        <summary><strong>Notifications Log</strong></summary>
          <ul v-if="entry.notifications.email.log" class="notification-log">
          <li v-for="(log, index) in logSort(entry.notifications.email.log)"
              :key="index" class="status" >

            <h3>{{ log.status }}</h3>
            <span class="time"> {{ timeAbsolute(log.time, true) }}</span>
            <span v-if="log.recipient">{{ log.recipient }}</span>
            <span class="api" v-if="log.status == 'accepted'">
              {{ entry.notifications.email.api }} API
            </span>

          </li>
        </ul>
        </details>
      </li>

      <li >
        <json-view :data="entry" rootKey="entry (raw data)" maxDepth="0" />
      </li>

    </ul>
  </div>
</div>

</div>
</template>

<script>
/* eslint-disable vue/no-mutating-props */
// import 'buefy/lib/buefy.css';
import {
  UserIcon, PhoneIcon, MailIcon, CalendarIcon, MessageSquareIcon, FileIcon, LinkIcon, ShieldIcon, ShieldOffIcon,
} from 'vue-feather-icons';
import { JSONView } from 'vue-json-component';
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import filesize from 'filesize';
import FormsService from '@/services/Forms';

export default {
  props: ['entry', 'form', 'modal'],
  computed: {
    otherFields() {
      const fields = { ...this.entry.data };
      ['name', 'phone', 'email', 'message', 'comments', 'files', 'Form URL'].forEach((e) => delete fields[e]);
      return fields;
    },
  },
  methods: {
    logSort(log) {
      return log.slice().sort((a, b) => new Date(a.time).getTime() - new Date(b.time).getTime());
    },
    timeAgo(string) {
      if (new Date(string) > new Date(new Date().getFullYear(), new Date().getMonth(), 1)) {
        return dayjs(string).fromNow();
      }
      if (new Date(string).getFullYear() < new Date().getFullYear()) return dayjs(string).format('MM/D/YY');
      return dayjs(string).format('MMMM Do');
    },
    timeAbsolute(string, short) {
      if (short) return dayjs(string).format('MMM D, h:mm:ss A');
      return dayjs(string).format('dddd, MMMM D YYYY - h:mm A');
    },
    fileSize(string) {
      return filesize(string);
    },
    selected(e) {
      this.$parent.viewEntry(e, this.entry.id);
      if (document.querySelectorAll('.entry.selected').length !== 0) {
        document.querySelectorAll('.entry.selected')[0].classList.remove('selected');
      }
      e.target.closest('.entry').classList.add('selected');
      this.modal = true;
    },
    close() {
      this.$emit('closeModal');
    },
    override(e) {
      const confirmText = 'Click again to confirm.';
      if (e.target.innerText === confirmText) {
        FormsService.overrideFormEntryByID(this.form.id, this.entry.id).then((response) => {
          if (response.data.override) {
            this.entry.meta.rejected = [];
            this.entry.meta.rejectOverride = response.data;
          }
        });
      } else e.target.innerText = confirmText;
    },
  },
  created() {
    dayjs.extend(relativeTime);
  },
  components: {
    UserIcon,
    PhoneIcon,
    MailIcon,
    CalendarIcon,
    MessageSquareIcon,
    FileIcon,
    LinkIcon,
    ShieldIcon,
    ShieldOffIcon,
    'json-view': JSONView,
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .modal-card-body li.rejected {
    position: sticky;
    top: 0;
    z-index: 1;
    background: var(--red);
    color: white;
    padding: 15px;
    padding-bottom: 5px;
    margin-bottom: 10px;
    border-radius: 5px;
  }

  .rejectionOverride button {
    margin: 0 1em;
  }

  .entry-filelist ul {
    list-style-type: none;
    padding: 0;
  }

  .entry-file img { max-width: 100%; }

  .notification-log {
    list-style-type: none;
    padding-left: 40px;
    font-size: 80%;
  }

  .notification-log li.status {
    padding: 5px;
    width: 150px;
  }

  .notification-log li.status:before {
    width: 8px;
    height: 8px;
    content: '';
    position: absolute;
    background: var(--green);
    border-radius: 50%;
    left: -20px;
    top: 13px;
  }

  .notification-log li.status:not(:last-of-type):after {
    width: 2px;
    height: 100%;
    content: '';
    background: var(--green);
    position: absolute;
    left: -17px;
    top: 13px;
  }

  .notification-log h3, .notification-log .api {
    margin: 0;
    text-transform: capitalize;
  }

  .notification-log .time {
    font-weight: normal;
    white-space: nowrap;
  }

  .modal {
    color: var(--black);
    align-items: center;
    display: none;
    justify-content: center;
    overflow: hidden;
    bottom: 0;
    left: 0;
    position: absolute;
    right: 0;
    top: 0;
    z-index: 99;
  }

  .modal.is-active {
    display: flex;
  }

  .modal-background {
    bottom: 0;
    left: 0;
    position: absolute;
    right: 0;
    top: 0;
    background-color: rgba(10, 10, 10, 0.86);
  }

  .modal-content,
  .modal-card {
    margin: 0 20px;
    max-height: calc(100vh - 160px);
    overflow: auto;
    position: relative;
    width: 100%;
  }

  .modal-card-body {
    margin-top: 0;
    list-style-type: none;
  }

@media screen and (min-width: 769px), print {
  .modal-content,
  .modal-card {
    margin: 0 auto;
    max-height: calc(100vh - 40px);
    width: 640px;
  }
}

.modal-close {
  background: none;
  height: 40px;
  position: fixed;
  right: 20px;
  top: 20px;
  width: 40px;
}

.modal-card {
  display: flex;
  flex-direction: column;
  max-height: calc(100vh - 40px);
  overflow: hidden;
}

.modal-card-head,
.modal-card-foot {
  align-items: center;
  background-color: whitesmoke;
  display: flex;
  flex-shrink: 0;
  justify-content: flex-start;
  padding: 20px;
  position: relative;
}

.modal-card-head {
  border-bottom: 1px solid #dbdbdb;
  border-top-left-radius: 6px;
  border-top-right-radius: 6px;
}

.modal-card-title {
  color: #363636;
  flex-grow: 1;
  flex-shrink: 0;
  font-size: 1.5rem;
  line-height: 1;
}

.modal-card-foot {
  border-bottom-left-radius: 6px;
  border-bottom-right-radius: 6px;
  border-top: 1px solid #dbdbdb;
}

.modal-card-foot .button:not(:last-child) {
  margin-right: 10px;
}

.modal-card-body {
  -webkit-overflow-scrolling: touch;
  background-color: white;
  flex-grow: 1;
  flex-shrink: 1;
  overflow: auto;
  padding: 20px;
}
.delete, .modal-close {
  -moz-appearance: none;
  -webkit-appearance: none;
  background-color: rgba(10, 10, 10, 0.2);
  border: none;
  border-radius: 290486px;
  cursor: pointer;
  display: inline-block;
  flex-grow: 0;
  flex-shrink: 0;
  font-size: 0;
  height: 20px;
  max-height: 20px;
  max-width: 20px;
  min-height: 20px;
  min-width: 20px;
  outline: none;
  position: relative;
  vertical-align: top;
  width: 20px;
}

.delete::before, .modal-close::before, .delete::after, .modal-close::after {
  background-color: white;
  content: "";
  display: block;
  left: 50%;
  position: absolute;
  top: 50%;
  -webkit-transform: translateX(-50%) translateY(-50%) rotate(45deg);
          transform: translateX(-50%) translateY(-50%) rotate(45deg);
  -webkit-transform-origin: center center;
          transform-origin: center center;
}

.delete::before, .modal-close::before {
  height: 2px;
  width: 50%;
}

.delete::after, .modal-close::after {
  height: 50%;
  width: 2px;
}

.delete:hover, .modal-close:hover, .delete:focus, .modal-close:focus {
  background-color: rgba(10, 10, 10, 0.3);
}

.delete:active, .modal-close:active {
  background-color: rgba(10, 10, 10, 0.4);
}

.is-small.delete, .is-small.modal-close {
  height: 16px;
  max-height: 16px;
  max-width: 16px;
  min-height: 16px;
  min-width: 16px;
  width: 16px;
}

.is-medium.delete, .is-medium.modal-close {
  height: 24px;
  max-height: 24px;
  max-width: 24px;
  min-height: 24px;
  min-width: 24px;
  width: 24px;
}

.is-large.delete, .is-large.modal-close {
  height: 32px;
  max-height: 32px;
  max-width: 32px;
  min-height: 32px;
  min-width: 32px;
  width: 32px;
}

  .modal-card-body li:not(.entry-file) {
    padding-bottom: 2em;
    position: relative;
  }

  .modal-card-title .feather { vertical-align: middle }
  .modal-card-body li > .feather {
    position: absolute;
    margin-top: 10px;
  }

  .modal-card-body li > strong {
    padding-left: 40px;
    font-size: 1.1em;
    text-transform: capitalize;
  }

  .modal-card-body li p {
    padding-left: 40px;
  }

</style>
